import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
	providedIn: 'root'
})
export class OffcanvasService {
	private isOffcanvasVisible = new BehaviorSubject<boolean>(false);

	// Observable to expose the visibility status
	isOffcanvasVisible$ = this.isOffcanvasVisible.asObservable();

	// Method to toggle visibility
	toggleOffcanvas() {
		this.isOffcanvasVisible.next(!this.isOffcanvasVisible.value);
	}
	setOffcanvasVisibility(isVisible: boolean) {
		this.isOffcanvasVisible.next(isVisible); // Asigna el valor explícito
	}
}
